/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
  TranscriptOverview,
  TranscriptOverviewFromJSON,
  TranscriptOverviewToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchTranscriptsResponse
 */
export interface FetchTranscriptsResponse {
  /**
   * The transcripts available to the calling user.
   * @type {Array<TranscriptOverview>}
   * @memberof FetchTranscriptsResponse
   */
  transcripts: Array<TranscriptOverview>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchTranscriptsResponse
   */
  pagination?: PaginationResponse
}

export function FetchTranscriptsResponseFromJSON(
  json: any
): FetchTranscriptsResponse {
  return FetchTranscriptsResponseFromJSONTyped(json, false)
}

export function FetchTranscriptsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchTranscriptsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    transcripts: (json['transcripts'] as Array<any>).map(
      TranscriptOverviewFromJSON
    ),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchTranscriptsResponseToJSON(
  value?: FetchTranscriptsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    transcripts: (value.transcripts as Array<any>).map(
      TranscriptOverviewToJSON
    ),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
